import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const VISIT_TYPE_PATH = "/visit-type/v1";

export const getVisitTypeApi = async (params, options = {}) => await getRequest(VISIT_TYPE_PATH, params, options);

export const getVisitTypeByIdApi = async (id) =>
  await getRequest(`${VISIT_TYPE_PATH}/${id}`);

export const addVisitTypeApi = async (data) =>
  await postRequest(VISIT_TYPE_PATH, data);

export const updateVisitTypeApi = async (id, data) =>
  await putRequest(`${VISIT_TYPE_PATH}/${id}`, data);

export const deleteVisitTypeByIdApi = async (id) =>
  await deleteRequest(`${VISIT_TYPE_PATH}/${id}`);
